<template>
  <el-form ref="form" :model="form" :rules="rules" label-position="right" label-width="180px">
    <el-row>
      <el-col :span="12">
        <el-form-item label="护理站名称">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属区域">
          <el-input v-model="form.area"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="护理站LOGO">
          <el-upload
            class="avatar-uploader"
            action='#'
            :http-request="uploadFile"
            :show-file-list="false"
            accept="image/*"
          >
            <img v-if="form.logo" :src="form.logo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item class="full">
      <template #label>
        入住医院 <br><span class="red" style="color: red">（多个医院，使用,隔开）</span>
      </template>
      <el-input v-model="form.hospital" type="textarea" class="full" placeholder="多个医院，使用,分开"></el-input>
    </el-form-item>
    <el-form-item class="full">
      <template #label>
        患者所属乡镇 <br><span class="red" style="color: red">（多个乡镇，使用,隔开）</span>
      </template>
      <el-input v-model="form.town" type="textarea" class="full" placeholder="多个乡镇，使用,隔开"></el-input>
    </el-form-item>
    <el-form-item label="民政局提供的特困人员名单">
      <el-upload
        class="upload-demo"
        :http-request="uploadPovertyFile"
        :limit="1"
        :file-list="povertyFileList"
        action='#'
        :show-file-list="false"
        :on-remove="handleRemovePovertyFile"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
    </el-form-item>
    <el-form-item label="申请须知">
      <el-input v-model="form.remark" type="textarea" class="full" :autosize="{
        minRows: 20
      }" placeholder="申请须知"></el-input>
    </el-form-item>

<!--    保存  -->
    <el-form-item class="full">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="$router.push('/nurse-station-management')">返回</el-button>
    </el-form-item>
  </el-form>
</template>
<script>

import pictureCompress from 'picture-compressor'
import { stationDetail, stationEdit, stationImport, stationInsert, uploadImgs } from '../../api'

// function getFileNameFromUrl(url) {
//   try {
//     const urlObj = new URL(url)
//     const path = urlObj.pathname
//     const fileName = path.split('/').pop()
//     return fileName
//   } catch (error) {
//     console.error('无效的URL:', error)
//     return ''
//   }
// }

export default {
  name: 'NursingStationManagementEdit',
  data() {
    return {
      id: null,
      povertyFileList: [],
      form: {
        title: '',
        logo: null,
        area: '',
        town: '',
        hospital: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入护理站名称', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.id = this.$route.query.id
    if (this.id) {
      this.getDetail()
    }
  },
  methods: {
    getDetail() {
      stationDetail({
        id: this.id
      }).then(res => {
        if (res.status) {
          const { data: {
            title,
            logo,
            area,
            town,
            remark,
            hospital
          } } = res
          this.form = {
            title,
            logo,
            area,
            town,
            remark,
            hospital
          }
          this.povertyFileList = [
          ]
        }
      })
    },
    onSubmit() {
      const vm = this
      vm.$refs['form'].validate((valid) => {
        if (valid) {
          const params = {
            ...vm.form
          }
          let c = stationInsert
          if (this.id) {
            params.id = this.id
            c = stationEdit
          }

          c(params).then(res => {
            if (res.status) {
              this.$router.push('/nurse-station-management')
              this.$message.success(res.msg)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    uploadFile(item) {
      const _this = this
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      reader.onload = function() {
        pictureCompress({
          img: reader.result,
          width: 500,
          height: 500
        }).then(res => {
          const params = {
            data: res.img,
            fileName: item.file.uid
          }
          uploadImgs(params)
            .then(resp => {
              if (resp.status) {
                _this.form.logo = resp.data.url
              }
            })
            .catch(() => {

            })
        })
      }
    },
    uploadPovertyFile(item) {
      const formData = new FormData()
      formData.append('file', item.file) // file是要上传的文件对象，可以通过<input type="file">元素获取
      stationImport(formData)
        .then(resp => {
          console.log(resp)
          if (resp.status) {
            this.$message.success(resp.msg)
          } else {
            this.$message.error(resp.msg)
          }
        })
        .catch(() => {

        })
    },
    handleRemovePovertyFile(file) {
      this.povertyFileList.map((fileData, key) => {
        if (fileData.uid === file.uid) {
          this.povertyFileList.splice(key, 1)
        }
      })
    }
  }
}

</script>
<style scoped lang="scss">
.full {
  width: 100%;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px!important;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
.upload-demo {
  width: 360px;
}
</style>
